module.exports = __webpack_public_path__ + "img/word.953be022.svg";